import { ApiService } from './apiService';

export const AmountService = {
    getAllAmount: async () => {
        try {
          const response =  ApiService.get('/Amount');
          return response;
      
        } catch (error) {
            ApiService.handleApiError('Error al obtener montos:', error);
          throw error;
        }
    },
    
    getAmountById: async (id) => {
    try {
        const response = await ApiService.get(`/Amount/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error al obtener el monto con id ${id}:`, error);
        throw error;
    }
    },
    
    createAmount: async (amountData) => {
    try {
        const response = await ApiService.post('/Amount', amountData);
        return response.data;
    } catch (error) {
        console.error('Error al crear el monto:', error);
        throw error;
    }
    },
    
    editAmount: async (id, amountData) => {
    try {
        amountData.id = id;
        const response = await ApiService.put(`/Amount/${id}`, amountData);
        return response.data;
    } catch (error) {
        console.error('Error al editar el monto:', error);
        throw error;
    }
    },
    
    deleteAmount: async (id) => {
    try {
        const response = await ApiService.delete(`/Amount/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al desactivar:', error);
        throw error;
    }
    },

}